export default "__VITE_PUBLIC_ASSET__12afea5a__"